import api, { MilestoneApp } from 'api';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { LTHeader, LTItem, LTPlaceholder, LTMobileItem } from 'components/common/ListTable';
import { CustomLTRow } from '../../customLTRow/customLTRow';
import Tip from './Tip/Tip';
import { useWindowSize } from 'hooks/useWindowSize';
import { ReactComponent as ExclamationPointIcon } from 'assets/icons/exclamation_mark.svg';
import * as S from '../../Table.styled';
import { useTranslation } from 'react-i18next';
import { convertToCurrencySymbol } from 'utils/convertToCurrencySymbol';
// import IconBtn from 'components/common/IconBtn';
// import { ReactComponent as DownloadIcon } from 'assets/icons/downloadB2b.svg';
// import { ReactComponent as VisibilityOffIcon } from 'assets/icons/visibility_off.svg';
// import { statusOptions } from 'data/constants/paymentStatuse';
// import PDFViewer from 'components/common/PDFViewer/PDFViewer';
import { PaymentStatus } from 'api/models/payload/ClientsPayload';

export default function AgreementB2B() {
    const { entity: activeApp } = useSelector((state: RootState) => state.application);
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const [milestones, setMilestones] = useState<MilestoneApp[]>([]);
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);
    const [currency, setCurrency] = useState<string>('USD');
    // const [invoiceUrl, setInvoiceUrl] = useState<string | null>(null);

    useEffect(() => {
        //def val
        setCurrency('USD');
        if (milestones && milestones.length > 0) {
            setCurrency(milestones[0].currency);
        }
    }, [activeApp?.id, milestones]);

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    useEffect(() => {
        const fetchData = async (appId: number) => {
            try {
                const response = await api.application.milestones.get(appId.toString());
                setMilestones(response.data);
            } catch (e) {
                console.error(e);
            }
        };
        if (activeApp) {
            fetchData(activeApp.id);
        }
    }, [activeApp]);

    const getTotalPrice = () => {
        if (milestones) {
            const prices = milestones.map((mil) => Number(mil.price));
            const totalFee = prices.reduce<number>((acc, curr) => {
                const tmp = acc + curr;
                return tmp;
            }, 0);
            return totalFee.toFixed(2);
        }
        return (0).toFixed(2);
    };

    const { t } = useTranslation();

    // const downloadInvoice = async (appId: string, milestoneId: string) => {
    //     try {
    //         const resp = await api.application.getMilestoneInvoice(appId, milestoneId);
    //         const blob = new Blob([resp.data], { type: 'application/pdf' }); // Adjust MIME type if needed

    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `invoice-${milestoneId}.pdf`; // customize filename
    //         document.body.appendChild(a);
    //         a.click();
    //         document.body.removeChild(a);
    //         window.URL.revokeObjectURL(url);
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    // const viewInvoice = async (appId: string, milestoneId: string) => {
    //     try {
    //         const resp = await api.application.getMilestoneInvoice(appId, milestoneId);
    //         const blob = new Blob([resp.data], { type: 'application/pdf' });
    //         const url = window.URL.createObjectURL(blob);
    //         setInvoiceUrl(url);
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    // const editMilestonePaymentStatus = async (
    //     appId: string,
    //     milestoneId: string,
    //     payload: string
    // ) => {
    //     try {
    //         console.log('trigerred');
    //         const resp = await api.application.editMilestonesPaymentStatus(
    //             appId,
    //             milestoneId,
    //             payload
    //         );
    //     } catch (err) {
    //         console.log(err);
    //     }
    // };

    return (
        <S.ListTable>
            <LTHeader>
                {/* tooltips are present in LTItem itself */}
                <LTItem maxWidth="20%" minWidth="20%">
                    {t('milestone', { lng: language })}
                </LTItem>

                <LTItem maxWidth="35%" minWidth="35%">
                    {t('explanation', { lng: language })}
                </LTItem>
                <LTItem maxWidth="10%" minWidth="10%" style={{ textAlign: 'center' }}>
                    {t('fee', { lng: language })}
                </LTItem>
                {/* <LTItem maxWidth="20%" minWidth="20%" style={{ textAlign: 'center' }}>
                    {t('status', { lng: language })}
                </LTItem> */}
                {/* <LTItem maxWidth="15%" minWidth="15%" style={{ textAlign: 'center' }}>
                    {t('actions', { lng: language })}
                </LTItem> */}
            </LTHeader>
            {milestones.length === 0 && (
                <LTPlaceholder>{t('theListIsEmpty', { lng: language })}</LTPlaceholder>
            )}
            {milestones.length > 0 &&
            activeApp?.payment_status !== PaymentStatus.FULLY_PAID &&
            mobile ? (
                <Tip
                    style={{ padding: '3px 10px', marginBottom: '20px' }}
                    icon={ExclamationPointIcon}
                >
                    {t('promptRetainerPayments', { lng: language })}
                </Tip>
            ) : (
                <div />
            )}
            {milestones.map((milestone: MilestoneApp, i) => {
                // const paymentStatus = milestone?.payment_status || 'PENDING';
                // const statusMatch = statusOptions.find(
                //     (opt) => opt.value === paymentStatus || opt.label === paymentStatus
                // );
                // const paymentStatuslabel = statusMatch?.label;
                // const statusColor = statusMatch?.color || '#8353E2';
                return (
                    <CustomLTRow key={i} id={i.toString()}>
                        {/*FULL SCREEN VERSION*/}
                        <LTItem maxWidth="20%" minWidth="20%">
                            {milestone.name}
                        </LTItem>
                        <LTItem maxWidth="35%" minWidth="35%">
                            {milestone.description}
                        </LTItem>
                        <LTItem maxWidth="10%" minWidth="10%" style={{ textAlign: 'center' }}>
                            {milestone.price}
                        </LTItem>
                        {/* <LTItem
                            maxWidth="20%"
                            minWidth="20%"
                            style={{ display: 'flex', justifyContent: 'center' }}>
                            <S.DropdownButton color={statusColor}>
                                {paymentStatuslabel ? paymentStatuslabel : 'Payment Pending'}
                            </S.DropdownButton>
                        </LTItem> */}
                        {/* <LTItem maxWidth="15%" minWidth="15%" style={{ textAlign: 'center' }}>
                            <IconBtn
                                variant="primary"
                                onClick={() => {
                                    viewInvoice(
                                        milestone.application_id.toString(),
                                        milestone?.id.toString()
                                    );
                                }}>
                                <VisibilityOffIcon fill={'#282828'} />
                            </IconBtn>
                            <IconBtn
                                variant="primary"
                                onClick={() => {
                                    downloadInvoice(
                                        milestone.application_id.toString(),
                                        milestone?.id.toString()
                                    );
                                }}>
                                <DownloadIcon fill={'#282828'} />
                            </IconBtn>
                        </LTItem> */}
                        {/*SMALL SCREEN VERSION*/}
                        <LTMobileItem name={t('milestone', { lng: language })}>
                            {milestone.name}
                        </LTMobileItem>
                        <LTMobileItem name={t('explanation', { lng: language })}>
                            {milestone.description}
                        </LTMobileItem>
                        <LTMobileItem name={t('fee', { lng: language })}>
                            ${milestone.price}
                        </LTMobileItem>
                        {/* <LTMobileItem name={t('status', { lng: language })}>
                            Payment Received
                        </LTMobileItem>{' '} */}
                        {/* <LTMobileItem name={t('fee', { lng: language })}>
                            <IconBtn
                                variant="primary"
                                onClick={() => {
                                    console.log('dowload');
                                }}>
                                <VisibilityOffIcon fill={'#282828'} />
                            </IconBtn>
                            <IconBtn
                                variant="primary"
                                onClick={() => {
                                    console.log('dowload');
                                }}>
                                <DownloadIcon fill={'#282828'} />
                            </IconBtn>
                        </LTMobileItem> */}
                    </CustomLTRow>
                );
            })}
            {milestones.length > 0 && (
                <CustomLTRow>
                    {!mobile && activeApp?.payment_status !== PaymentStatus.FULLY_PAID ? (
                        <Tip icon={ExclamationPointIcon}>
                            {t('promptRetainerPayments', { lng: language })}
                        </Tip>
                    ) : (
                        <div />
                    )}

                    <LTItem
                        maxWidth="20%"
                        minWidth="120px"
                        style={{ textAlign: 'center', fontWeight: '700' }}
                    >
                        {t('total', { lng: language })}: {convertToCurrencySymbol(currency)}{' '}
                        {getTotalPrice()}
                    </LTItem>
                    <LTMobileItem
                        style={{
                            textAlign: 'end',
                            fontWeight: '700',
                            gap: '4px',
                            alignSelf: 'flex-end',
                        }}
                        name={`${t('total', { lng: language })}`}
                    >
                        ${getTotalPrice()}
                    </LTMobileItem>
                </CustomLTRow>
            )}

            {/* {invoiceUrl && (
                <div
                    style={{
                        marginTop: '1rem',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        width: '100%',
                    }}>
                    <PDFViewer file={invoiceUrl} />
                </div>
            )} */}
        </S.ListTable>
    );
}
